import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class Grid_BookingModel extends BaseModel {

    constructor(source?: Grid_BookingModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._bookingID = 0;
            this._requestedTherapistID = 0;
            this._assignedTherapistID = 0;
            this._contactMethodID = 0;
            this._bookingStatusID = 0;
            this._eventID = 0;
        }
    }

// private properties
    _bookingID: number = 0;
    _bookingDate: Date = new Date();
    _requestedTherapistID: number | null = null;
    _requestedTherapist: string = "";
    _assignedTherapistID: number | null = null;
    _assignedTherapist: string = "";
    _fullName: string | null = null;
    _mobileNumber: string | null = null;
    _contactMethodID: number | null = null;
    _contactMethodName: string | null = null;
    _location: string | null = null;
    _otherNotes: string | null = null;
    _bookingStatusID: number = 0;
    _bookingStatusName: string | null = null;
    _treatmentStart: Date | null = null;
    _treatmentEnd: Date | null = null;
    _reference: string = "";
    _eventID: number | null = null;
    _eventName: string | null = null;
    _venueName: string | null = null;
    _statusName: string | null = null;

// public properties
    public get bookingID(): number
    {
        return this._bookingID;
    }
    public set bookingID(v: number)
    {
        if (v !== this._bookingID)
        {
            this._bookingID = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingID", this));
        }
    }

    public get bookingDate(): Date
    {
        return this._bookingDate;
    }
    public set bookingDate(v: Date)
    {
        if (v !== this._bookingDate)
        {
            this._bookingDate = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingDate", this));
        }
    }

    public get requestedTherapistID(): number | null
    {
        return this._requestedTherapistID;
    }
    public set requestedTherapistID(v: number | null)
    {
        if (v !== this._requestedTherapistID)
        {
            this._requestedTherapistID = v;
            this.propertyChanged.emit(new propertyChangedArguments("requestedTherapistID", this));
        }
    }

    public get requestedTherapist(): string
    {
        return this._requestedTherapist;
    }
    public set requestedTherapist(v: string)
    {
        if (v !== this._requestedTherapist)
        {
            this._requestedTherapist = v;
            this.propertyChanged.emit(new propertyChangedArguments("requestedTherapist", this));
        }
    }

    public get assignedTherapistID(): number | null
    {
        return this._assignedTherapistID;
    }
    public set assignedTherapistID(v: number | null)
    {
        if (v !== this._assignedTherapistID)
        {
            this._assignedTherapistID = v;
            this.propertyChanged.emit(new propertyChangedArguments("assignedTherapistID", this));
        }
    }

    public get assignedTherapist(): string
    {
        return this._assignedTherapist;
    }
    public set assignedTherapist(v: string)
    {
        if (v !== this._assignedTherapist)
        {
            this._assignedTherapist = v;
            this.propertyChanged.emit(new propertyChangedArguments("assignedTherapist", this));
        }
    }

    public get fullName(): string | null
    {
        return this._fullName;
    }
    public set fullName(v: string | null)
    {
        if (v !== this._fullName)
        {
            this._fullName = v;
            this.propertyChanged.emit(new propertyChangedArguments("fullName", this));
        }
    }

    public get mobileNumber(): string | null
    {
        return this._mobileNumber;
    }
    public set mobileNumber(v: string | null)
    {
        if (v !== this._mobileNumber)
        {
            this._mobileNumber = v;
            this.propertyChanged.emit(new propertyChangedArguments("mobileNumber", this));
        }
    }

    public get contactMethodID(): number | null
    {
        return this._contactMethodID;
    }
    public set contactMethodID(v: number | null)
    {
        if (v !== this._contactMethodID)
        {
            this._contactMethodID = v;
            this.propertyChanged.emit(new propertyChangedArguments("contactMethodID", this));
        }
    }

    public get contactMethodName(): string | null
    {
        return this._contactMethodName;
    }
    public set contactMethodName(v: string | null)
    {
        if (v !== this._contactMethodName)
        {
            this._contactMethodName = v;
            this.propertyChanged.emit(new propertyChangedArguments("contactMethodName", this));
        }
    }

    public get location(): string | null
    {
        return this._location;
    }
    public set location(v: string | null)
    {
        if (v !== this._location)
        {
            this._location = v;
            this.propertyChanged.emit(new propertyChangedArguments("location", this));
        }
    }

    public get otherNotes(): string | null
    {
        return this._otherNotes;
    }
    public set otherNotes(v: string | null)
    {
        if (v !== this._otherNotes)
        {
            this._otherNotes = v;
            this.propertyChanged.emit(new propertyChangedArguments("otherNotes", this));
        }
    }

    public get bookingStatusID(): number
    {
        return this._bookingStatusID;
    }
    public set bookingStatusID(v: number)
    {
        if (v !== this._bookingStatusID)
        {
            this._bookingStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingStatusID", this));
        }
    }

    public get bookingStatusName(): string | null
    {
        return this._bookingStatusName;
    }
    public set bookingStatusName(v: string | null)
    {
        if (v !== this._bookingStatusName)
        {
            this._bookingStatusName = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingStatusName", this));
        }
    }

    public get treatmentStart(): Date | null
    {
        return this._treatmentStart;
    }
    public set treatmentStart(v: Date | null)
    {
        if (v !== this._treatmentStart)
        {
            this._treatmentStart = v;
            this.propertyChanged.emit(new propertyChangedArguments("treatmentStart", this));
        }
    }

    public get treatmentEnd(): Date | null
    {
        return this._treatmentEnd;
    }
    public set treatmentEnd(v: Date | null)
    {
        if (v !== this._treatmentEnd)
        {
            this._treatmentEnd = v;
            this.propertyChanged.emit(new propertyChangedArguments("treatmentEnd", this));
        }
    }

    public get reference(): string
    {
        return this._reference;
    }
    public set reference(v: string)
    {
        if (v !== this._reference)
        {
            this._reference = v;
            this.propertyChanged.emit(new propertyChangedArguments("reference", this));
        }
    }

    public get eventID(): number | null
    {
        return this._eventID;
    }
    public set eventID(v: number | null)
    {
        if (v !== this._eventID)
        {
            this._eventID = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventID", this));
        }
    }

    public get eventName(): string | null
    {
        return this._eventName;
    }
    public set eventName(v: string | null)
    {
        if (v !== this._eventName)
        {
            this._eventName = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventName", this));
        }
    }

    public get venueName(): string | null
    {
        return this._venueName;
    }
    public set venueName(v: string | null)
    {
        if (v !== this._venueName)
        {
            this._venueName = v;
            this.propertyChanged.emit(new propertyChangedArguments("venueName", this));
        }
    }

    public get statusName(): string | null
    {
        return this._statusName;
    }
    public set statusName(v: string | null)
    {
        if (v !== this._statusName)
        {
            this._statusName = v;
            this.propertyChanged.emit(new propertyChangedArguments("statusName", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: Grid_BookingModel): void {
        if (source == null) return;
        this._bookingID = source.bookingID;
        this._bookingDate = source.bookingDate;
        this._requestedTherapistID = source.requestedTherapistID;
        this._requestedTherapist = source.requestedTherapist;
        this._assignedTherapistID = source.assignedTherapistID;
        this._assignedTherapist = source.assignedTherapist;
        this._fullName = source.fullName;
        this._mobileNumber = source.mobileNumber;
        this._contactMethodID = source.contactMethodID;
        this._contactMethodName = source.contactMethodName;
        this._location = source.location;
        this._otherNotes = source.otherNotes;
        this._bookingStatusID = source.bookingStatusID;
        this._bookingStatusName = source.bookingStatusName;
        this._treatmentStart = source.treatmentStart;
        this._treatmentEnd = source.treatmentEnd;
        this._reference = source.reference;
        this._eventID = source.eventID;
        this._eventName = source.eventName;
        this._venueName = source.venueName;
        this._statusName = source.statusName;
    }


}
